import { service } from '../../../helpers/http'

const unwrap = (response) => (response && response.data !== undefined ? response.data : response)

export const ActionGetLearningPath = ({ commit }, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'getLearningPath',
        payload,
    }).then((response) => {
        const data = unwrap(response)
        commit('SET_LEARNING_PATH', data)
        return data
    })
}

export const ActionGetLearningPathCourses = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'getCourses',
        payload,
    }).then(unwrap)
}

export const ActionGetLearningPathGroups = (_, payload) => {
    // routParams cobre TODOS os filtros: courseId (substitui {courseId} na URL)
    // + shift_id + work_time_id (viram query string). Vue Resource em GET ignora
    // o segundo argumento (payload/body), então qualquer filtro precisa estar
    // explicitamente em routParams pra chegar no backend.
    const routParams = { courseId: payload.courseId }
    if (payload.shift_id) routParams.shift_id = payload.shift_id
    if (payload.work_time_id) routParams.work_time_id = payload.work_time_id

    return service({
        module: 'domainLearningPath',
        action: 'getGroupsByCourse',
        payload,
        params: routParams,
    }).then(unwrap)
}

export const ActionAddManualCompletion = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'addManual',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionRemoveManualCompletion = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'removeManual',
        payload,
        params: { id: payload.id, disciplineId: payload.disciplineId },
    }).then(unwrap)
}

export const ActionGetManualCompletionHistory = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'historyManual',
        payload,
        params: { id: payload.id, disciplineId: payload.disciplineId },
    }).then(unwrap)
}

export const ActionListOfferIntents = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'listOfferIntents',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionAddOfferIntent = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'addOfferIntent',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionRemoveOfferIntent = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'removeOfferIntent',
        payload,
        params: { id: payload.id, disciplineId: payload.disciplineId },
    }).then(unwrap)
}

export const ActionGetOfferWorkTimes = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'offerWorkTimes',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionSetEnabledOfferIntent = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'setEnabledOfferIntent',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionClearOfferIntent = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'clearOfferIntent',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionBulkRemoveOfferIntent = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'bulkRemoveOfferIntent',
        payload,
        params: { id: payload.id },
    }).then(unwrap)
}

export const ActionGetJoinInfo = (_, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'joinInfo',
        payload,
        params: { id: payload.id, disciplineId: payload.disciplineId },
    }).then(unwrap)
}

export const ActionGetLearningPathAggregate = ({ commit }, payload) => {
    return service({
        module: 'domainLearningPath',
        action: 'getAggregate',
        payload,
    }).then((response) => {
        const data = unwrap(response)
        commit('SET_AGGREGATE_PATH', data)
        return data
    })
}
